import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ChatPanel from "../components/ChatPanel";
import { useOutletContext } from "react-router-dom";

export default function DesignHarmonyPage() {
  const navigate = useNavigate();

  const {
    user,
    project,
    form,
    roomOptions,
    selectedRoom,
    handleRoomSelectionChange,
  } = useOutletContext();

  // ─── Redirect if not logged in ─────────────────────────────────────
  useEffect(() => {
    if (!user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);
  // ───────────────────────────────────────────────────────────────────

  // Determine selected room details
  const roomDetails = roomOptions.find((room) => room.id === selectedRoom);

  return (
    <div className="design-project-page min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-10">
        {!roomDetails && <div>Please select a room from the sidebar.</div>}

        {roomDetails && (
          <div className="room-project-layout">
            <div className="room-project-top-row">
              {/* ChatPanel */}
              <div className="chat-panel" aria-label="ChatPanel">
                <ChatPanel project={project} room={roomDetails} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
